document.addEventListener("DOMContentLoaded", () => {
  new Swiper(".hero-carousel", {
    slidesPerView: 1,
    autoplay: { delay: 5000 },
    spaceBetween: 30,
    watchOverflow: true,
    navigation: {
      nextEl: ".custom-hero-carousel .hero-carousel-next",
      prevEl: ".custom-hero-carousel .hero-carousel-prev",
    },
    breakpoints: {
      807: { slidesPerView: "auto", spaceBetween: 20 },
    },
  });

  document.querySelectorAll(".custom-product-carousel").forEach((wrapper) => {
    const swiperEl = wrapper.querySelector(".swiper-product-carousel");
    const nextBtn =
      wrapper.querySelector(".product-carousel-next") ||
      wrapper.querySelector(".swiper-button-next");

    const prevBtn =
      wrapper.querySelector(".product-carousel-prev") ||
      wrapper.querySelector(".swiper-button-prev");

    if (!swiperEl || !nextBtn || !prevBtn) {
      console.warn("Product Swiper missing required elements", {
        swiperEl,
        nextBtn,
        prevBtn,
      });
      return;
    }

    new Swiper(swiperEl, {
      slidesPerView: 2,
      spaceBetween: 10,
      watchOverflow: true,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      breakpoints: {
        576: { slidesPerView: 3, spaceBetween: 20 },
        992: { slidesPerView: 4, spaceBetween: 20 },
        1200: { slidesPerView: 6, spaceBetween: 20 },
      },
    });
  });

  document.querySelectorAll(".custom-collection-carousel").forEach((wrapper) => {
    const swiperEl = wrapper.querySelector(".swiper-product-carousel");
    const nextBtn = wrapper.querySelector(".collection-carousel-next");
    const prevBtn = wrapper.querySelector(".collection-carousel-prev");

    if (!swiperEl || !nextBtn || !prevBtn) {
      console.warn("Collection Swiper missing required elements", {
        swiperEl,
        nextBtn,
        prevBtn,
      });
      return;
    }

    new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 10,
      watchOverflow: true,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      breakpoints: {
        576: { slidesPerView: 2, spaceBetween: 20 },
        1200: { slidesPerView: 3, spaceBetween: 20 },
      },
    });
  });
});
